import { BehaviorSubject } from "rxjs";


export const pairBehaviorSubjects = <T extends any>(...subjects: BehaviorSubject<T>[]) => {

  const subscriber = (value: T) => {
    subjects
      .filter((subject) => subject.value !== value)
      .forEach((subject) => {
        subject.next(value)
      })
  };

  const subscriptions = subjects.map((subject) => subject.subscribe(subscriber));

  return {
    dispose: () => subscriptions.forEach((subscription) => subscription.unsubscribe())
  }
}

